module.exports = __webpack_public_path__ + "static/media/path-b.21bdea3e.svg";